import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: ''
  });
  const [formStatus, setFormStatus] = useState('');

  const carouselImages = [
    {
      url: 'https://public.readdy.ai/ai/img_res/cb9b2dfe6d2dbe0ad8af7ba991a33d54.jpg',
      title: 'Equipo Profesional',
      description: 'Formamos enfermeras y enfermeros de excelencia'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Nurse%20providing%20compassionate%20patient%20care%20in%20modern%20hospital%20room%20with%20advanced%20medical%20technology%2C%20healthcare%20professional%20attending%20to%20patient%20with%20care%20and%20expertise%2C%20bright%20clinical%20environment%20with%20medical%20monitoring%20equipment%2C%20professional%20medical%20attention%20and%20quality%20healthcare%20service&width=1920&height=1080&seq=carousel002&orientation=landscape',
      title: 'Atención de Calidad',
      description: 'Aprende las mejores prácticas de cuidado'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Medical%20students%20in%20nursing%20training%20classroom%20with%20instructor%20demonstrating%20healthcare%20procedures%20on%20medical%20mannequins%2C%20professional%20education%20environment%20with%20modern%20teaching%20equipment%20and%20bright%20lighting%2C%20engaged%20students%20learning%20clinical%20skills%20in%20contemporary%20training%20facility&width=1920&height=1080&seq=carousel003&orientation=landscape',
      title: 'Educación Continua',
      description: 'Capacitación especializada y certificada'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Nurse%20using%20advanced%20medical%20technology%20and%20digital%20healthcare%20systems%20in%20modern%20hospital%20setting%2C%20healthcare%20professional%20working%20with%20electronic%20medical%20records%20and%20monitoring%20equipment%2C%20contemporary%20clinical%20workspace%20with%20innovative%20medical%20technology%2C%20professional%20healthcare%20innovation&width=1920&height=1080&seq=carousel004&orientation=landscape',
      title: 'Tecnología Avanzada',
      description: 'Aprende con equipos de última generación'
    }
  ];

  // Handle scroll for navbar
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('enviando');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nombre', formData.nombre);
      formBody.append('email', formData.email);
      formBody.append('telefono', formData.telefono);
      formBody.append('mensaje', formData.mensaje);

      const response = await fetch('https://readdy.ai/api/form/d55gc8kg267ndt4ac10g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setFormStatus('exitoso');
        setFormData({ nombre: '', email: '', telefono: '', mensaje: '' });
        setTimeout(() => setFormStatus(''), 3000);
      } else {
        setFormStatus('error');
      }
    } catch (error) {
      setFormStatus('error');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/58ea65af69aacb75e85048c3ddc24df1/a00bf88789f50b26cd29dc30ddde52dd.jpeg" 
                alt="CENCAEAN SAS Logo" 
                className="h-14 w-auto"
              />
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('inicio')} className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Inicio
              </button>
              <button onClick={() => scrollToSection('cursos')} className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Cursos
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('nosotros')} className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">
                Nosotros
              </button>
              <button onClick={() => scrollToSection('contacto')} className="px-6 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                Contacto
              </button>
            </div>

            {/* Mobile menu button */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-4 py-4 space-y-3">
              <button onClick={() => scrollToSection('inicio')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer">
                Inicio
              </button>
              <button onClick={() => scrollToSection('cursos')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer">
                Cursos
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('nosotros')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer">
                Nosotros
              </button>
              <button onClick={() => scrollToSection('contacto')} className="block w-full text-left px-4 py-2 text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-lg cursor-pointer">
                Contacto
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section with Carousel */}
      <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Carousel Container */}
        <div className="absolute inset-0 w-full h-full">
          {carouselImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img 
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
            </div>
          ))}
        </div>

        {/* Carousel Controls */}
        <button
          onClick={prevSlide}
          className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all cursor-pointer"
          aria-label="Anterior"
        >
          <i className="ri-arrow-left-s-line text-2xl text-white"></i>
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full transition-all cursor-pointer"
          aria-label="Siguiente"
        >
          <i className="ri-arrow-right-s-line text-2xl text-white"></i>
        </button>

        {/* Carousel Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-3">
          {carouselImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                index === currentSlide 
                  ? 'bg-white w-8' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Ir a imagen ${index + 1}`}
            ></button>
          ))}
        </div>
        
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            CENCAEAN SAS<br />
            <span className="text-teal-300">TE INVITA</span>
          </h1>
          <p className="text-2xl md:text-3xl text-white mb-8 font-light">
            A ser una gran profesional en el área de la salud
          </p>
          <p className="text-lg md:text-xl text-white/90 mb-12 max-w-3xl mx-auto">
            Formamos enfermeras y enfermeros altamente capacitados con los mejores programas de educación continua en el sector salud
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => scrollToSection('cursos')}
              className="px-8 py-4 bg-teal-600 text-white text-base font-semibold rounded-full hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Ver Nuestros Cursos
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="px-8 py-4 bg-white text-teal-600 text-base font-semibold rounded-full hover:bg-gray-50 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Contáctanos
            </button>
          </div>
        </div>
      </section>

      {/* Cursos Section */}
      <section id="cursos" className="py-24 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nuestros <strong className="text-teal-600">Cursos</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Programas especializados diseñados para impulsar tu carrera profesional en el área de la salud
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Curso 1 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer">
              <div className="relative h-56 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20nurse%20providing%20emergency%20care%20and%20first%20aid%20treatment%20in%20modern%20hospital%20emergency%20room%2C%20medical%20professional%20attending%20patient%20with%20care%20and%20expertise%2C%20bright%20clinical%20environment%20with%20medical%20equipment%2C%20clean%20professional%20healthcare%20setting&width=600&height=400&seq=curso001&orientation=landscape"
                  alt="Cuidados Intensivos"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-heart-pulse-line text-xl text-teal-600"></i>
                  </div>
                  <span className="text-xs font-semibold text-teal-600 uppercase tracking-wide">Especialización</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Cuidados Intensivos</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  Aprende técnicas avanzadas de atención en unidades de cuidados intensivos, manejo de pacientes críticos y protocolos de emergencia
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-gray-400"></i>
                    <span className="text-sm text-gray-600">120 horas</span>
                  </div>
                  <button className="text-sm font-semibold text-teal-600 hover:text-teal-700 whitespace-nowrap cursor-pointer">
                    Más información →
                  </button>
                </div>
              </div>
            </div>

            {/* Curso 2 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer">
              <div className="relative h-56 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Pediatric%20nurse%20caring%20for%20children%20in%20bright%20colorful%20pediatric%20ward%2C%20healthcare%20professional%20with%20young%20patients%20in%20cheerful%20hospital%20environment%2C%20gentle%20care%20and%20medical%20attention%20for%20kids%2C%20warm%20professional%20medical%20setting%20with%20child-friendly%20atmosphere&width=600&height=400&seq=curso002&orientation=landscape"
                  alt="Enfermería Pediátrica"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-parent-line text-xl text-teal-600"></i>
                  </div>
                  <span className="text-xs font-semibold text-teal-600 uppercase tracking-wide">Especialización</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Enfermería Pediátrica</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  Especialízate en el cuidado integral de niños y adolescentes, desde recién nacidos hasta la adolescencia, con enfoque humanizado
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-gray-400"></i>
                    <span className="text-sm text-gray-600">100 horas</span>
                  </div>
                  <button className="text-sm font-semibold text-teal-600 hover:text-teal-700 whitespace-nowrap cursor-pointer">
                    Más información →
                  </button>
                </div>
              </div>
            </div>

            {/* Curso 3 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer">
              <div className="relative h-56 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Surgical%20nurse%20preparing%20operating%20room%20with%20sterile%20medical%20instruments%20and%20equipment%2C%20professional%20healthcare%20worker%20in%20surgical%20scrubs%20organizing%20surgery%20preparation%2C%20clean%20modern%20operating%20theater%20with%20medical%20technology%2C%20precise%20clinical%20environment&width=600&height=400&seq=curso003&orientation=landscape"
                  alt="Enfermería Quirúrgica"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-surgical-mask-line text-xl text-teal-600"></i>
                  </div>
                  <span className="text-xs font-semibold text-teal-600 uppercase tracking-wide">Especialización</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Enfermería Quirúrgica</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  Domina las técnicas de instrumentación quirúrgica, esterilización y asistencia en procedimientos operatorios complejos
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-gray-400"></i>
                    <span className="text-sm text-gray-600">110 horas</span>
                  </div>
                  <button className="text-sm font-semibold text-teal-600 hover:text-teal-700 whitespace-nowrap cursor-pointer">
                    Más información →
                  </button>
                </div>
              </div>
            </div>

            {/* Curso 4 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer">
              <div className="relative h-56 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Geriatric%20nurse%20providing%20compassionate%20care%20to%20elderly%20patient%20in%20comfortable%20senior%20care%20facility%2C%20healthcare%20professional%20assisting%20older%20adult%20with%20dignity%20and%20respect%2C%20warm%20caring%20medical%20environment%20with%20natural%20light%2C%20professional%20elderly%20care%20setting&width=600&height=400&seq=curso004&orientation=landscape"
                  alt="Geriatría y Gerontología"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-user-heart-line text-xl text-teal-600"></i>
                  </div>
                  <span className="text-xs font-semibold text-teal-600 uppercase tracking-wide">Especialización</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Geriatría y Gerontología</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  Aprende el cuidado especializado del adulto mayor, manejo de enfermedades crónicas y atención geriátrica integral
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-gray-400"></i>
                    <span className="text-sm text-gray-600">90 horas</span>
                  </div>
                  <button className="text-sm font-semibold text-teal-600 hover:text-teal-700 whitespace-nowrap cursor-pointer">
                    Más información →
                  </button>
                </div>
              </div>
            </div>

            {/* Curso 5 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer">
              <div className="relative h-56 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Emergency%20medical%20technician%20responding%20to%20urgent%20medical%20situation%20with%20ambulance%20and%20emergency%20equipment%2C%20paramedic%20providing%20immediate%20care%20in%20emergency%20response%20scenario%2C%20professional%20urgent%20medical%20attention%20with%20modern%20emergency%20tools%2C%20dynamic%20healthcare%20emergency%20setting&width=600&height=400&seq=curso005&orientation=landscape"
                  alt="Urgencias y Emergencias"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-ambulance-line text-xl text-teal-600"></i>
                  </div>
                  <span className="text-xs font-semibold text-teal-600 uppercase tracking-wide">Especialización</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Urgencias y Emergencias</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  Capacítate en atención prehospitalaria, triage, reanimación cardiopulmonar y manejo de situaciones de emergencia
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-gray-400"></i>
                    <span className="text-sm text-gray-600">130 horas</span>
                  </div>
                  <button className="text-sm font-semibold text-teal-600 hover:text-teal-700 whitespace-nowrap cursor-pointer">
                    Más información →
                  </button>
                </div>
              </div>
            </div>

            {/* Curso 6 */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer">
              <div className="relative h-56 w-full overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Maternity%20nurse%20caring%20for%20newborn%20baby%20and%20mother%20in%20modern%20hospital%20maternity%20ward%2C%20healthcare%20professional%20providing%20postnatal%20care%20in%20bright%20clean%20delivery%20room%2C%20gentle%20maternal%20healthcare%20with%20medical%20equipment%2C%20warm%20professional%20birthing%20environment&width=600&height=400&seq=curso006&orientation=landscape"
                  alt="Enfermería Obstétrica"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-empathize-line text-xl text-teal-600"></i>
                  </div>
                  <span className="text-xs font-semibold text-teal-600 uppercase tracking-wide">Especialización</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Enfermería Obstétrica</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                  Especialízate en el cuidado de la mujer durante el embarazo, parto y puerperio, con enfoque en salud materno-infantil
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2">
                    <i className="ri-time-line text-gray-400"></i>
                    <span className="text-sm text-gray-600">105 horas</span>
                  </div>
                  <button className="text-sm font-semibold text-teal-600 hover:text-teal-700 whitespace-nowrap cursor-pointer">
                    Más información →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Descripción de Cursos Section */}
      <section id="descripcion" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                ¿Por qué elegir <strong className="text-teal-600">CENCAEAN SAS</strong>?
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Somos una institución líder en formación continua para profesionales de enfermería, comprometidos con la excelencia académica y el desarrollo de competencias prácticas que marcan la diferencia en el sector salud.
              </p>
              
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                    <i className="ri-shield-check-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Certificación Oficial</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      Todos nuestros cursos están avalados y certificados por instituciones reconocidas en el sector salud
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                    <i className="ri-team-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Docentes Expertos</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      Contamos con profesionales altamente calificados con amplia experiencia en el área clínica y docente
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                    <i className="ri-microscope-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Práctica Intensiva</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      Metodología práctica con simulación clínica y casos reales para garantizar el aprendizaje efectivo
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                    <i className="ri-calendar-check-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Horarios Flexibles</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      Adaptamos nuestros horarios a tus necesidades para que puedas estudiar sin descuidar tu trabajo
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative h-[600px] w-full rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Group%20of%20diverse%20nursing%20students%20in%20modern%20medical%20training%20classroom%20with%20instructor%20demonstrating%20healthcare%20procedures%2C%20professional%20medical%20education%20environment%20with%20training%20equipment%20and%20anatomical%20models%2C%20bright%20collaborative%20learning%20space%20with%20engaged%20students%20in%20scrubs%2C%20inspiring%20educational%20healthcare%20setting&width=800&height=1000&seq=desc001&orientation=portrait"
                  alt="Estudiantes de Enfermería"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-8 -left-8 bg-teal-600 text-white p-8 rounded-2xl shadow-xl max-w-xs">
                <div className="text-5xl font-bold mb-2">500+</div>
                <p className="text-sm font-medium">Profesionales capacitados con éxito</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonios Section */}
      <section id="testimonios" className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Lo que dicen nuestros <strong className="text-teal-600">estudiantes</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Historias reales de profesionales que transformaron su carrera con nuestros cursos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Testimonio 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xl text-yellow-400"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "El curso de Cuidados Intensivos superó todas mis expectativas. Los docentes son excelentes y la práctica en simulación me dio la confianza que necesitaba para trabajar en UCI. Totalmente recomendado."
              </p>
              <div className="flex items-center gap-4">
                <div className="relative w-14 h-14 flex items-center justify-center rounded-full overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20female%20nurse%20in%20medical%20scrubs%20smiling%20confidently%20in%20hospital%20setting%2C%20healthcare%20worker%20portrait%20with%20warm%20friendly%20expression%2C%20clean%20medical%20background%20with%20natural%20lighting%2C%20professional%20headshot%20of%20latina%20nursing%20professional&width=200&height=200&seq=test001&orientation=squarish"
                    alt="María González"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">María González</div>
                  <div className="text-sm text-gray-500">Enfermera UCI</div>
                </div>
              </div>
            </div>

            {/* Testimonio 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xl text-yellow-400"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "Gracias a CENCAEAN pude especializarme en Enfermería Pediátrica. La metodología es muy práctica y los conocimientos adquiridos los aplico diariamente en mi trabajo. Una inversión que vale la pena."
              </p>
              <div className="flex items-center gap-4">
                <div className="relative w-14 h-14 flex items-center justify-center rounded-full overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20male%20nurse%20in%20medical%20uniform%20smiling%20warmly%20in%20pediatric%20hospital%20ward%2C%20confident%20healthcare%20professional%20portrait%20with%20caring%20expression%2C%20bright%20clinical%20background%20with%20natural%20light%2C%20professional%20headshot%20of%20latino%20nursing%20specialist&width=200&height=200&seq=test002&orientation=squarish"
                    alt="Carlos Mendoza"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Carlos Mendoza</div>
                  <div className="text-sm text-gray-500">Enfermero Pediátrico</div>
                </div>
              </div>
            </div>

            {/* Testimonio 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xl text-yellow-400"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "La especialización en Urgencias y Emergencias me abrió muchas puertas laborales. El contenido es actualizado y muy completo. Los profesores tienen mucha experiencia y eso se nota en cada clase."
              </p>
              <div className="flex items-center gap-4">
                <div className="relative w-14 h-14 flex items-center justify-center rounded-full overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20female%20emergency%20nurse%20in%20scrubs%20with%20confident%20smile%20in%20hospital%20emergency%20department%2C%20dedicated%20healthcare%20worker%20portrait%20with%20professional%20demeanor%2C%20modern%20medical%20facility%20background%20with%20soft%20lighting%2C%20professional%20headshot%20of%20latina%20emergency%20medical%20professional&width=200&height=200&seq=test003&orientation=squarish"
                    alt="Ana Rodríguez"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Ana Rodríguez</div>
                  <div className="text-sm text-gray-500">Enfermera de Emergencias</div>
                </div>
              </div>
            </div>

            {/* Testimonio 4 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xl text-yellow-400"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "Excelente institución. El curso de Enfermería Quirúrgica me permitió desarrollar habilidades que no tenía. Los horarios flexibles me ayudaron a combinar estudio y trabajo sin problemas."
              </p>
              <div className="flex items-center gap-4">
                <div className="relative w-14 h-14 flex items-center justify-center rounded-full overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20male%20surgical%20nurse%20in%20operating%20room%20attire%20smiling%20confidently%2C%20experienced%20healthcare%20professional%20portrait%20with%20surgical%20cap%20and%20scrubs%2C%20clean%20modern%20hospital%20background%20with%20professional%20lighting%2C%20professional%20headshot%20of%20latino%20surgical%20nursing%20specialist&width=200&height=200&seq=test004&orientation=squarish"
                    alt="Luis Fernández"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Luis Fernández</div>
                  <div className="text-sm text-gray-500">Enfermero Quirúrgico</div>
                </div>
              </div>
            </div>

            {/* Testimonio 5 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xl text-yellow-400"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "Me encantó el curso de Geriatría. Aprendí técnicas específicas para el cuidado del adulto mayor que aplico en mi día a día. La atención personalizada de los instructores es increíble."
              </p>
              <div className="flex items-center gap-4">
                <div className="relative w-14 h-14 flex items-center justify-center rounded-full overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20female%20geriatric%20nurse%20smiling%20warmly%20in%20senior%20care%20facility%2C%20compassionate%20healthcare%20worker%20portrait%20with%20caring%20expression%2C%20comfortable%20medical%20environment%20with%20natural%20lighting%2C%20professional%20headshot%20of%20latina%20geriatric%20nursing%20specialist&width=200&height=200&seq=test005&orientation=squarish"
                    alt="Patricia Morales"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Patricia Morales</div>
                  <div className="text-sm text-gray-500">Enfermera Geriátrica</div>
                </div>
              </div>
            </div>

            {/* Testimonio 6 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xl text-yellow-400"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                "La especialización en Enfermería Obstétrica fue una experiencia transformadora. El nivel académico es alto y las prácticas son muy completas. Ahora trabajo en maternidad con total seguridad."
              </p>
              <div className="flex items-center gap-4">
                <div className="relative w-14 h-14 flex items-center justify-center rounded-full overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20female%20obstetric%20nurse%20in%20maternity%20ward%20uniform%20smiling%20confidently%2C%20dedicated%20maternal%20healthcare%20worker%20portrait%20with%20warm%20expression%2C%20bright%20hospital%20maternity%20background%20with%20soft%20lighting%2C%20professional%20headshot%20of%20latina%20obstetric%20nursing%20professional&width=200&height=200&seq=test006&orientation=squarish"
                    alt="Sandra Jiménez"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900">Sandra Jiménez</div>
                  <div className="text-sm text-gray-500">Enfermera Obstétrica</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Misión y Visión Section */}
      <section id="nosotros" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nuestra <strong className="text-teal-600">Identidad</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Conoce los valores y principios que guían nuestra labor educativa
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Misión */}
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-10 shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-2xl mb-6">
                <i className="ri-compass-3-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Misión</h3>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Formar profesionales de enfermería altamente capacitados mediante programas de educación continua de excelencia, que contribuyan al mejoramiento de la calidad de atención en salud en nuestra comunidad.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                Nos comprometemos a brindar una formación integral, práctica y actualizada, basada en evidencia científica y valores humanísticos, que permita a nuestros estudiantes desarrollar competencias técnicas y humanas para ejercer con profesionalismo y ética en el sector salud.
              </p>
            </div>

            {/* Visión */}
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-10 shadow-lg">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-2xl mb-6">
                <i className="ri-eye-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Visión</h3>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Ser reconocidos como la institución líder en formación continua para profesionales de enfermería en la región, destacándonos por la calidad académica, innovación pedagógica y el impacto positivo de nuestros egresados en el sistema de salud.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                Aspiramos a expandir nuestra oferta educativa, incorporar tecnologías de vanguardia en la enseñanza y mantener alianzas estratégicas con instituciones de salud que garanticen la empleabilidad y desarrollo profesional de nuestros estudiantes.
              </p>
            </div>
          </div>

          {/* Valores */}
          <div className="mt-16">
            <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Nuestros <strong className="text-teal-600">Valores</strong>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                  <i className="ri-heart-line text-2xl text-teal-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Excelencia</h4>
                <p className="text-sm text-gray-600">Compromiso con la calidad en cada aspecto de nuestra formación</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                  <i className="ri-hand-heart-line text-2xl text-teal-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Humanismo</h4>
                <p className="text-sm text-gray-600">Cuidado centrado en la persona con calidez y empatía</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-teal-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Ética</h4>
                <p className="text-sm text-gray-600">Integridad y responsabilidad en el ejercicio profesional</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                  <i className="ri-lightbulb-line text-2xl text-teal-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">Innovación</h4>
                <p className="text-sm text-gray-600">Actualización constante con las mejores prácticas</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* QR Code Section */}
      <section className="py-24 bg-gradient-to-br from-teal-50 via-white to-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Acceso <strong className="text-teal-600">Rápido</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Escanea el código QR para acceder directamente a nuestra página web desde tu dispositivo móvil
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                {/* QR Code Area */}
                <div className="bg-gradient-to-br from-teal-600 to-teal-700 p-12 flex flex-col items-center justify-center">
                  <div className="bg-white p-8 rounded-2xl shadow-xl mb-6">
                    <div className="w-64 h-64 flex items-center justify-center">
                      <img 
                        src="https://static.readdy.ai/image/58ea65af69aacb75e85048c3ddc24df1/d2a111433588a3ae5017383811046ee9.jpeg"
                        alt="Código QR CENCAEAN SAS"
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full mb-2">
                      <i className="ri-smartphone-line text-white text-lg"></i>
                      <span className="text-sm text-white font-semibold">Escanea con tu móvil</span>
                    </div>
                  </div>
                </div>

                {/* Instructions Area */}
                <div className="p-12 flex flex-col justify-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">¿Cómo usar el código QR?</h3>
                  
                  <div className="space-y-5">
                    <div className="flex gap-4">
                      <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full text-teal-600 font-bold">
                        1
                      </div>
                      <div>
                        <h4 className="text-base font-bold text-gray-900 mb-1">Abre la cámara</h4>
                        <p className="text-sm text-gray-600">Usa la cámara de tu teléfono móvil o tablet</p>
                      </div>
                    </div>

                    <div className="flex gap-4">
                      <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full text-teal-600 font-bold">
                        2
                      </div>
                      <div>
                        <h4 className="text-base font-bold text-gray-900 mb-1">Escanea el código</h4>
                        <p className="text-sm text-gray-600">Apunta la cámara hacia el código QR</p>
                      </div>
                    </div>

                    <div className="flex gap-4">
                      <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full text-teal-600 font-bold">
                        3
                      </div>
                      <div>
                        <h4 className="text-base font-bold text-gray-900 mb-1">Accede al sitio</h4>
                        <p className="text-sm text-gray-600">Toca la notificación para abrir nuestra página</p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-8 p-4 bg-teal-50 rounded-xl">
                    <div className="flex items-start gap-3">
                      <i className="ri-information-line text-teal-600 text-xl mt-0.5"></i>
                      <div>
                        <p className="text-sm text-gray-700 font-semibold mb-1">Acceso instantáneo:</p>
                        <p className="text-xs text-gray-600 leading-relaxed">
                          Escanea este código QR desde cualquier dispositivo móvil para acceder directamente a nuestra página web y conocer todos nuestros cursos de enfermería.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Benefits */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
              <div className="text-center p-6 bg-white rounded-xl shadow-md">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full text-teal-600 font-bold">
                  <i className="ri-speed-line text-2xl"></i>
                </div>
                <h4 className="text-base font-bold text-gray-900 mb-2">Acceso Instantáneo</h4>
                <p className="text-sm text-gray-600">Ingresa a nuestra web en segundos</p>
              </div>

              <div className="text-center p-6 bg-white rounded-xl shadow-md">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full text-teal-600 font-bold">
                  <i className="ri-share-line text-2xl"></i>
                </div>
                <h4 className="text-base font-bold text-gray-900 mb-2">Fácil de Compartir</h4>
                <p className="text-sm text-gray-600">Comparte con amigos y colegas</p>
              </div>

              <div className="text-center p-6 bg-white rounded-xl shadow-md">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full text-teal-600 font-bold">
                  <i className="ri-smartphone-line text-2xl"></i>
                </div>
                <h4 className="text-base font-bold text-gray-900 mb-2">100% Mobile</h4>
                <p className="text-sm text-gray-600">Optimizado para dispositivos móviles</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contacto Section */}
      <section id="contacto" className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              <strong className="text-teal-600">Contáctanos</strong>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Estamos aquí para resolver tus dudas y ayudarte a iniciar tu camino hacia la excelencia profesional
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Información de Contacto */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-8">Información de Contacto</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                    <i className="ri-phone-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-1">Teléfonos</h4>
                    <a href="tel:0968048092" className="text-sm text-gray-600 hover:text-teal-600 block cursor-pointer">0968048092</a>
                    <a href="tel:0995652318" className="text-sm text-gray-600 hover:text-teal-600 block cursor-pointer">0995652318</a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                    <i className="ri-mail-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-1">Email</h4>
                    <a href="mailto:centrodecapacitaciones54@gmail.com" className="text-sm text-gray-600 hover:text-teal-600 cursor-pointer">centrodecapacitaciones54@gmail.com</a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                    <i className="ri-time-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-1">Horario de Atención</h4>
                    <p className="text-sm text-gray-600">Lunes a Viernes: 8:00 AM - 6:00 PM</p>
                    <p className="text-sm text-gray-600">Sábados: 9:00 AM - 2:00 PM</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl">
                    <i className="ri-map-pin-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="text-base font-bold text-gray-900 mb-1">Ubicación</h4>
                    <p className="text-sm text-gray-600">Ecuador</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-6 bg-teal-50 rounded-2xl">
                <h4 className="text-lg font-bold text-gray-900 mb-3">¿Listo para comenzar?</h4>
                <p className="text-sm text-gray-600 mb-4">
                  Completa el formulario y nos pondremos en contacto contigo para brindarte toda la información sobre nuestros cursos y modalidades de inscripción.
                </p>
                <div className="flex items-center gap-2 text-sm text-teal-600 font-semibold">
                  <i className="ri-checkbox-circle-line text-lg"></i>
                  <span>Respuesta en menos de 24 horas</span>
                </div>
              </div>
            </div>

            {/* Formulario */}
            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Envíanos un mensaje</h3>
              
              <form id="contactForm" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nombre completo *
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all"
                    placeholder="Tu nombre completo"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all"
                    placeholder="0999999999"
                  />
                </div>

                <div>
                  <label htmlFor="mensaje" className="block text-sm font-semibold text-gray-700 mb-2">
                    Mensaje *
                  </label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    value={formData.mensaje}
                    onChange={handleChange}
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Cuéntanos sobre tu interés en nuestros cursos..."
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
                </div>

                <button
                  type="submit"
                  disabled={formStatus === 'enviando'}
                  className="w-full px-6 py-4 bg-teal-600 text-white text-base font-semibold rounded-lg hover:bg-teal-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {formStatus === 'enviando' ? 'Enviando...' : 'Enviar Mensaje'}
                </button>

                {formStatus === 'exitoso' && (
                  <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-sm text-green-800 flex items-center gap-2">
                      <i className="ri-checkbox-circle-line text-lg"></i>
                      ¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.
                    </p>
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-sm text-red-800 flex items-center gap-2">
                      <i className="ri-error-warning-line text-lg"></i>
                      Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.
                    </p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div className="md:col-span-2">
              <img 
                src="https://static.readdy.ai/image/58ea65af69aacb75e85048c3ddc24df1/a00bf88789f50b26cd29dc30ddde52dd.jpeg" 
                alt="CENCAEAN SAS" 
                className="h-16 mb-4"
              />
              <p className="text-sm text-teal-50 leading-relaxed mb-4">
                Centro de capacitación especializado en formación continua para profesionales de enfermería, comprometidos con la excelencia y el desarrollo del sector salud.
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-base font-bold mb-4">Enlaces Rápidos</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <button onClick={() => scrollToSection('inicio')} className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    Inicio
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('cursos')} className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    Cursos
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('testimonios')} className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    Testimonios
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('nosotros')} className="text-teal-50 hover:text-white transition-colors cursor-pointer">
                    Nosotros
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-base font-bold mb-4">Contacto</h4>
              <ul className="space-y-2 text-sm text-teal-50">
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>0968048092</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>0995652318</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>centrodecapacitaciones54@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-teal-500/30 text-center">
            <p className="text-sm text-teal-50">
              © 2025 CENCAEAN SAS. Todos los derechos reservados. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}